import Vue from 'vue'
import Vuex from 'vuex'
/*
import app from './modules/app'
import user from './modules/user'
*/
import getters from './getters'

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', false, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})


export function autoinitModules () {
  return dispatchModules('autoinit')
}
export function autodestroyModules () {
  return dispatchModules('autodestroy')
}
/**
 * dispatch action for each modules if the action is present
 *
 * @returns promise that returns results for modules
 */
function dispatchModules (action) {
  let promises = []
  let results = {}
  let t = Date.now()
  for (let moduleName of Object.keys(modules)) {
    const module = modules[moduleName]
    if (module.actions[action]) {
      const type = (module.namespaced ? moduleName + '/' : '') + action
      const p = Promise.resolve(moduleName).then((moduleName) => {
        return store.dispatch(type)
          .catch((e) => e)
          .then((res) => {
            results[moduleName] = res
          })
      })
      promises.push(p)
    }
  }
  return Promise.all(promises)
    .then(() => {
      // TODO: print errors?
      console.log('%o modules finished in %o ms', action, (Date.now() - t))
    })
    .then(() => results)
}

const store = new Vuex.Store({
  modules,
  getters
})
window.modules = modules
/*
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production', // activated for proper vuex-using
  modules: {
    app,
    user
  },
  getters
})
*/

export default store



// WEBPACK FOOTER //
// ./src/store/index.js